// register the plugin on vue
import Vue from 'vue';
import axios from 'axios';
import router from '../router'
import { isExpired, logOut, loginPath } from './auth'

Vue.prototype.$axios = axios

// APIのエンドポイントを設定（docker-compose.ymlに記載）
Vue.prototype.$axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

// ログイン永続化
if (sessionStorage.getItem('ShingakushaEpro')) {
  const strageData = JSON.parse(sessionStorage.getItem('ShingakushaEpro'));
  // sessionStrageにデータがあったらヘッダーに値を設定する
  if (strageData.user.accessToken) {
      Vue.prototype.$axios.defaults.headers.common['access-token'] = strageData.user.accessToken;
      Vue.prototype.$axios.defaults.headers.common['client']       = strageData.user.client;
      Vue.prototype.$axios.defaults.headers.common['uid']          = strageData.user.uid;
  }
}

Vue.prototype.$axios.interceptors.request.use(
	(request) => {
    // request時に一定時間操作がなかったら
    if (request.url !== '/api/v1/auth/sign_out' && isExpired()) {
      // お試しアカウントは/otameshiへ。logOutでstoreがクリアされる前に判定
      const path = loginPath()
      logOut()
      request.url = '/api/v1/auth/sign_out'
      request.method = 'delete'
      request.data = undefined
      if (router.history.current.name !== 'SignIn' && router.history.current.name !== 'Otameshi') {
        router.push(path)
      }
      Vue.toasted.global.error({ message: '一定時間操作がありませんでした。お手数ですが、再度ログインの上ご利用をお願いします。' })
    }

    return request
  }
)

Vue.prototype.$axios.interceptors.response.use(
	(response) => {
		return response
	},
	(error) => {
    // responseが空の場合
    if (!error.response) {
      if (process.env.NODE_ENV !== 'development') Vue.prototype.$awsRum.recordError(error)
      return Promise.reject(error)
    }

    // response.statusが空の場合
    if (!error.response.status) {
      if (process.env.NODE_ENV !== 'development') Vue.prototype.$awsRum.recordError(error)
      return Promise.reject(error)
    }

    // メンテナンスモード検知
    if (
      error.response.status === 503 &&
      error.response.headers['x-maintenance'] === 'true'
    ) {
      // store は循環参照回避のため遅延 require
      require('../store/index.js').default.dispatch('maintenance/enable')
      return Promise.reject(error)
    }

		// 認証が切れた時の処理（ログイン失敗）
		if (error.response.status == 401) {
      Vue.toasted.global.error({ message: error.response.data.errors })
      // ログイン画面(/sign_in・/otameshi)でのログイン失敗時は遷移させない。それ以外はお試しなら/otameshiへ
      if (router.history.current.name !== 'SignIn' && router.history.current.name !== 'Otameshi') router.push(loginPath())
      return Promise.reject(error)
    }
    // バリデーション失敗時の処理
		else if (error.response.status == 422) {
      Vue.toasted.global.error({ message: error.response.data.messages })
      return Promise.reject(error)
    }

    else {
      if (process.env.NODE_ENV !== 'development') Vue.prototype.$awsRum.recordError(error)
      return Promise.reject(error)
    }
	}
)
